import React, { Component, ReactFragment } from 'react';
import { digiDocsUrl, printUrl } from '../../utils/api/appControl';
import IFramePage from './iframePage';
import { isStaticHtmlMode, isStaticMode } from '../../utils/general/general';
import { IReducerState } from '../../states/renditionStates';
import { connect } from 'react-redux';

interface IHtmlPdfTogglePanelProps {
    container: ReactFragment;
    isJP: boolean;
    isOfflineReading: boolean;
    showPDFDigidocViewer: boolean;
    htmlPDFtoggleStatus: boolean;
    showOldBranding: boolean
}

interface IHtmlPdfTogglePanelStatus {
    toggleStatus: boolean;
    url: any;
}

export class HtmlPdfTogglePanel extends Component<IHtmlPdfTogglePanelProps, IHtmlPdfTogglePanelStatus> {

    constructor(props: any) {
        super(props);
        this.state = {
            toggleStatus: true,
            url: ''
        };
    }

    public componentDidMount() {
        if (!this.props.isOfflineReading || isStaticHtmlMode()) {
            printUrl(this.props.isJP).then((response) => this.setState({url: response}));
            return;
        }

        if (this.props.isOfflineReading) {
            this.setState({url: digiDocsUrl('html')});
        }
    }

    public render() {
        const showHTMLPDFTogglePane = this.props.showPDFDigidocViewer &&
            window.HTML_RENDITION.initialData.productType !== 'blog' &&
            window.HTML_RENDITION.initialData.mode !== 'preview_mode' &&
            !isStaticMode();

        return (
            <div className={showHTMLPDFTogglePane ? 'togglePane' : ''}>
                <div className={this.props.htmlPDFtoggleStatus ? '' : 'd-none'}>{this.props.container}</div>
                {showHTMLPDFTogglePane && (
                    <div className={(this.props.htmlPDFtoggleStatus ? 'd-none' : '') + ' pdf-panel-wrapper'}>
                        <iframe
                            src={this.state.url}
                            frameBorder="0"
                            className="rendition-iframe"
                        />
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        htmlPDFtoggleStatus: state.commonStateReducer.htmlPDFtoggleStatus,
    };
};

export default connect(mapStateToProps)(HtmlPdfTogglePanel);
